import React from 'react';
import PropTypes from 'prop-types';
import IconNikeAI from '../IconNikeAI';
import { StyledButton } from './styles';

/**
 * Nike AI Shimmer Button
 * Reusable shimmer button component for Nike AI entry points
 * Used by both FAB and AskNikeAI search result
 *
 * @param {Object} props
 * @param {Function} props.onClick - Click handler
 * @param {string} props.ariaLabel - Accessible label
 * @param {string} props.size - 'small' (48px) or 'large' (62px desktop, 56px mobile)
 * @param {string} props.className - Additional CSS class
 * @param {number} props.tabIndex - Tab index for accessibility
 */
const NikeAIShimmerButton = ({
  onClick,
  ariaLabel = 'Nike AI',
  size = 'small',
  className = '',
  tabIndex = 0,
}) => {
  return (
    <StyledButton
      aria-label={ariaLabel}
      className={className}
      onClick={onClick}
      size={size}
      tabIndex={tabIndex}
      type="button"
    >
      <IconNikeAI ariaLabel="" />
    </StyledButton>
  );
};

NikeAIShimmerButton.propTypes = {
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['small', 'large']),
  tabIndex: PropTypes.number,
};

NikeAIShimmerButton.defaultProps = {
  ariaLabel: 'Nike AI',
  className: '',
  size: 'small',
  tabIndex: 0,
};

export default NikeAIShimmerButton;
